export enum PersonType {
    Fisica = 'Pessoa Física',
    Juridica = 'Fundo de investimento',
    PJInvestidor = 'PJ',
    Gestor = 'Gestor',
    Emissor = 'Emissor',
    Escrituracao = 'Escrituração',
    Liquidacao = 'Liquidante',
}
